import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-tapable-terminal-card',
    templateUrl: './tapable-terminal-card.component.html',
    styleUrls: ['./tapable-terminal-card.component.scss'],
    standalone: false
})
export class TapableTerminalCard {

  @Input() size = 250;

}
